var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplication4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2243 1323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#bdd0fb;}.cls-3{fill:#dce5fe;}.cls-4{fill:#2b69b3;}.cls-5{fill:#91b3fa;}.cls-6{fill:#18174a;}.cls-7,.cls-8{fill:#fff;}.cls-8{opacity:0.78;}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:#7d97f4;}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}.cls-34{fill:url(#linear-gradient-26);}.cls-35{fill:url(#linear-gradient-27);}.cls-36{fill:url(#linear-gradient-28);}.cls-37{fill:url(#linear-gradient-29);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#linear-gradient-39);}.cls-48{fill:url(#linear-gradient-40);}.cls-49{fill:url(#linear-gradient-41);}.cls-50{fill:url(#linear-gradient-42);}.cls-51{fill:url(#linear-gradient-43);}.cls-52{fill:url(#linear-gradient-44);}.cls-53{fill:url(#linear-gradient-45);}.cls-54{fill:url(#linear-gradient-46);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1683.54,
    y1: 638.97,
    x2: 528.02,
    y2: 638.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 528.13, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1076.82,
    y1: 826.97,
    x2: 826.2,
    y2: 162.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 879.58,
    y1: -394.86,
    x2: 858.58,
    y2: 313.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1254.5,
    y1: 736.72,
    x2: 1848.77,
    y2: 714.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1548.59,
    y1: -375.02,
    x2: 1527.58,
    y2: 333.05,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 971.94,
    y1: 742.27,
    x2: 1720.79,
    y2: 760.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1777.82,
    y1: 879.7,
    x2: 2025.57,
    y2: 879.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1770.42,
    y1: 1156.71,
    x2: 2031.12,
    y2: 1156.71,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1861.25,
    y1: 994.21,
    x2: 1971.72,
    y2: 921.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1880.91,
    y1: 1030.23,
    x2: 1962.74,
    y2: 976.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1862.42,
    y1: 1063.51,
    x2: 1944.25,
    y2: 1009.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 317.53,
    y1: 1141.16,
    x2: 354.53,
    y2: 955.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 447.06,
    y1: 1267.13,
    x2: 470.8,
    y2: 1267.13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 559.49,
    y1: 1269.13,
    x2: 587.83,
    y2: 1269.13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 380.12,
    y1: 849.8,
    x2: 450.74,
    y2: 849.8,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 392.42,
    y1: 939.07,
    x2: 416.24,
    y2: 939.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 521.44,
    y1: 1006.82,
    x2: 586.9,
    y2: 1006.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 98.4,
    y1: 2441.21,
    x2: 34.7,
    y2: 2525.48,
    gradientTransform: "translate(23.17 -1598) rotate(-8.21)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 5.1,
    y1: 2507.94,
    x2: 56.2,
    y2: 2455.52,
    gradientTransform: "translate(23.17 -1598) rotate(-8.21)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 486.74,
    y1: 1168.55,
    x2: 565.59,
    y2: 1168.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 576.27,
    y1: 1168.55,
    x2: 655.12,
    y2: 1168.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 554.17,
    y1: 1077.08,
    x2: 588.13,
    y2: 1077.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1732.89,
    y1: 1184.32,
    x2: 1822.89,
    y2: 1288.32,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1639.26,
    y1: 1001.28,
    x2: 1665.26,
    y2: 1152.28,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1755.06,
    y1: 870.82,
    x2: 1788.39,
    y2: 952.82,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1712.05,
    y1: 883.81,
    x2: 1763.31,
    y2: 883.81,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1748.98,
    y1: 869.03,
    x2: 1761.07,
    y2: 869.03,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1846.92,
    y1: 902.11,
    x2: 1806.25,
    y2: 1026.11,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1622.07,
    y1: 562.31,
    x2: 1654.87,
    y2: 562.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1647.76,
    y1: 565.54,
    x2: 1693.08,
    y2: 565.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1673.82,
    y1: 562.88,
    x2: 1719.24,
    y2: 562.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1704.44,
    y1: 558.42,
    x2: 1739.77,
    y2: 558.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1727.74,
    y1: 553.47,
    x2: 1768.67,
    y2: 553.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1909.35,
    y1: 520.28,
    x2: 1957.3,
    y2: 520.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1927.22,
    y1: 508.84,
    x2: 1984.56,
    y2: 508.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1977.9,
    y1: 515.09,
    x2: 2007.14,
    y2: 515.09,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1985.18,
    y1: 465.6,
    x2: 2036.79,
    y2: 465.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 2011.21,
    y1: 448.2,
    x2: 2054.54,
    y2: 448.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 2157.42,
    y1: 431.53,
    x2: 2217.3,
    y2: 431.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 2141.64,
    y1: 446.35,
    x2: 2196.42,
    y2: 446.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 2153.01,
    y1: 500.03,
    x2: 2176.62,
    y2: 500.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 2136.48,
    y1: 509.71,
    x2: 2155.85,
    y2: 509.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1544.15,
    y1: 501.72,
    x2: 1572.22,
    y2: 501.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1525.31,
    y1: 498.69,
    x2: 1549.11,
    y2: 498.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1505.19,
    y1: 474.67,
    x2: 1519.95,
    y2: 474.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1425.88,
    y1: 454.24,
    x2: 1433.78,
    y2: 454.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1648.41,1249s196.67-23.06,290-5,324.71-79.7,248-233.06S2012.69,819.87,2113,736s142.18-300.91,38.77-390.66-134.54,2.59-216.92-30.46,22.23-205.47-210.51-254.2-413.58,98.5-519.4,81.87S936.4,24,822.2,28.29s-100,154.35-251.56,145.6S300.15,150,202,277.78s-74.56,289.77,19,353.8,75.33,150.14-97.23,155.08S-29.33,970.19,111.48,1102s261.61,133.31,402.26,142S1648.41,1249,1648.41,1249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1369.26,1171.38c-2,3.89-7.91,1-6.08-3,35-76.47,23.45-42.52,53-107.71,73.88-163,46.48-253,60.6-344.05s103.94-183.6,240-101.46c111.1,67.08,199.35,116.78,245.66,124.37a11.14,11.14,0,0,1,6.11,18.77c-41.43,42.53-146.7,135-258.33,109.69-143.7-32.58-133.54-71.53-174.78-43.69s-51.27,64.8-70.63,133.92C1448.14,1017.8,1446.9,1022.29,1369.26,1171.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1470.07,898.54a291.9,291.9,0,0,1-.29-35.1,306.39,306.39,0,0,1,3.6-34.82c3.83-23,10.37-45.9,21.41-66.91A147.41,147.41,0,0,1,1515,732.42a121.09,121.09,0,0,1,27.47-22.94,133.12,133.12,0,0,1,32.89-13.87c5.64-1.45,11.25-3,17-4.15,5.68-1.33,11.44-2.28,17.2-3.27a261.65,261.65,0,0,1,34.94-3.05,217.27,217.27,0,0,1,35,2.53,226.08,226.08,0,0,1,34.09,8.13c11.1,3.54,21.92,7.8,32.54,12.31,21.25,9.08,41.9,19,63.27,27a297.29,297.29,0,0,0,66.09,16.94h0a2,2,0,0,1-.47,3.88,302.1,302.1,0,0,1-67.59-15.41c-21.9-7.55-42.87-17.25-64.06-25.78s-42.8-15.7-65.12-18.83a208,208,0,0,0-33.65-2,253.41,253.41,0,0,0-33.62,3.38c-5.55,1-11.11,2-16.61,3.39-5.53,1.17-11,2.76-16.44,4.24a124.81,124.81,0,0,0-30.33,13c-18.81,11.51-33.52,28.9-43.77,48.59-10.4,19.7-16.78,41.56-20.52,63.78a324.45,324.45,0,0,0-3.83,33.67,284.3,284.3,0,0,0-.15,33.78v.18a4.68,4.68,0,0,1-9.34.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M820.87,596.12S813.73,472,754,443.48s-169.94-40.4-188.5-218c-10.87-104-17.15-149.28-20.5-169a11.77,11.77,0,0,1,12.83-13.69c54.87,5.78,233.84,33.38,280.41,150.21C893.41,331.55,820.87,596.12,820.87,596.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M603.92,88.54c18.06,13.5,34.59,28.54,50.69,44.15l6,5.89,5.86,6c3.91,4,7.82,8,11.59,12.16,7.68,8.17,15,16.68,22.35,25.13,7.13,8.65,14.36,17.24,21.08,26.22,6.95,8.82,13.47,18,20,27.09,12.67,18.59,25.09,37.19,35.81,57.19,2.67,5,5.41,10,8,15l7,15.49,3.5,7.75,3,7.93,6,15.9,5.08,16.19,2.52,8.1,2.11,8.21c1.38,5.48,2.86,10.93,4.1,16.44L822,420c8.19,44.42,11.08,89.52,6.75,134.67a4.85,4.85,0,0,1-9.67-.63v-.3a507.63,507.63,0,0,0-2-65.75,598.36,598.36,0,0,0-9.63-65.12l-3.55-16c-1.33-5.32-2.83-10.58-4.2-15.88l-2.1-7.93-2.51-7.81-5-15.61-5.86-15.29-2.9-7.66L778,329.22l-6.71-14.92c-2.49-4.85-5.11-9.62-7.66-14.44-4.89-9.69-10.86-19-16.42-28.51-2.76-4.77-5.9-9.29-8.84-14s-5.85-9.33-9.05-13.82c-12.23-18.34-25.39-36-38.93-53.46-6.93-8.59-13.82-17.22-21.05-25.56-3.51-4.27-7.17-8.4-10.83-12.54L653,145.81l-5.62-6.09c-14.91-16.28-30.5-32.12-46.84-46.86l-.08-.07a2.75,2.75,0,0,1,3.49-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M836.14,1149.42c11.66,6.66-104.22-159.7-127.88-410.91C697.12,620.12,706.2,473.27,643,412.44c-52.58-50.62-243.54-32.89-306.13-25.52a9.3,9.3,0,0,0-5.34,16c28.08,26.8,87.82,89.6,100.59,149.88C449,632.21,520.06,686.58,585.66,704.24s101.73,33,127.36,141.37S803,1130.48,836.14,1149.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M421.81,425.61s1.9.14,5.38.57,8.6,1.1,15,2.32,14.23,2.88,23.07,5.22a297.36,297.36,0,0,1,29.26,9.3,302.21,302.21,0,0,1,33.27,14.82,255.21,255.21,0,0,1,34.61,21.57,226.39,226.39,0,0,1,32.39,29.43,206.32,206.32,0,0,1,26.37,36.83l2.73,5c.93,1.66,1.81,3.35,2.58,5.09,1.6,3.47,3.23,6.81,4.75,10.41q4.15,10.3,8.28,20.5c5.5,13.57,10.86,26.94,16,39.91l7.59,19.08c1.29,3.1,2.37,6.26,3.46,9.36s2.18,6.17,3.24,9.19c4.25,12.1,8.26,23.55,12,34.11l5.26,15.16c1.5,4.87,2.92,9.5,4.25,13.84,2.65,8.69,5,16.26,6.87,22.5s3.18,11.22,4.12,14.59,1.39,5.18,1.39,5.18a1.89,1.89,0,0,1-3.62,1.1l0-.07-1.7-5c-1.14-3.29-2.67-8.14-4.9-14.25s-4.83-13.55-7.88-22.08q-2.28-6.39-4.84-13.57C678.9,711,677,706,675,700.78L662.2,667.21c-2.31-5.94-4.46-12.1-7.07-18.29s-5.18-12.54-7.85-19c-5.35-12.88-10.82-26.2-16.33-39.77q-4.14-10.17-8.35-20.48c-1.37-3.22-3-6.54-4.5-9.83-.72-1.67-1.55-3.28-2.43-4.87l-2.58-4.8c-14-25.48-34-47.42-55.72-64.1a262.1,262.1,0,0,0-33-21.77A298.64,298.64,0,0,0,492.24,449c-10.24-4.13-19.79-7.57-28.38-10.24s-16.19-4.66-22.48-6.13-11.28-2.48-14.68-3.09-5.22-.85-5.22-.85a1.52,1.52,0,0,1,.31-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1300.17,1000c-11.66,6.66,104.22-159.69,127.88-410.91,11.14-118.38,2.06-265.24,65.23-326.07,52.58-50.62,243.54-32.89,306.13-25.52a9.3,9.3,0,0,1,5.34,16c-28.08,26.8-87.82,89.6-100.59,149.88-16.84,79.46-87.91,133.82-153.51,151.48s-101.73,33.05-127.36,141.37S1333.29,981.05,1300.17,1000Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1434.45,624.8a4.33,4.33,0,0,1-1.12-.16,4.12,4.12,0,0,1-2.84-5.08c.22-.8,23.1-80.94,75.57-203.84,15.4-36.07,49.48-85.91,124.42-118.52,44.65-19.43,82.19-23.45,83.76-23.61a4.12,4.12,0,1,1,.84,8.19c-1.49.16-150.06,16.82-201.44,137.17-52.27,122.42-75,202.06-75.23,202.85A4.12,4.12,0,0,1,1434.45,624.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M725.48,1168.57c7.15,3.77-40.3-77.9-43.94-149.85S661.67,824,599.61,750.48,469.61,670.32,384,737.1c-71.35,55.66-115.86,83.75-142,89a9.86,9.86,0,0,0-6.62,14.38C252.15,871.28,299.48,942.1,379,937.11c101.37-6.36,224.23-72.26,261.67-17.28s32.64,85.73,33.79,111.78S678.13,1143.61,725.48,1168.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.89,825.47a202.65,202.65,0,0,1,17.65-14.87,230.47,230.47,0,0,1,19-13.12,189.29,189.29,0,0,1,42-19.86,131.2,131.2,0,0,1,23-5.2,98.15,98.15,0,0,1,23.92-.1c2,.32,4,.51,6,.95s4,.84,5.88,1.38l11.2,3.47,11,4.27,10.62,5.11a133.38,133.38,0,0,1,37,29c10.57,11.65,18.81,25.09,25.58,39l2.55,5.22c.87,1.73,1.5,3.56,2.27,5.33,1.43,3.59,3,7.13,4.32,10.74l3.76,10.92c1.32,3.61,2.16,7.37,3.23,11.06a397.83,397.83,0,0,1,9.6,44.88,1.69,1.69,0,0,1-3.3.68v-.06c-3.62-14.73-7.08-29.49-12-43.75-2.25-7.21-5.08-14.18-7.71-21.22-1.42-3.48-3-6.86-4.54-10.29-.8-1.7-1.46-3.45-2.36-5.09l-2.62-5a169.25,169.25,0,0,0-25.32-36.43,129.71,129.71,0,0,0-34.88-26.58l-10-4.73-10.33-3.95L547.8,784c-1.76-.5-3.48-.83-5.22-1.26s-3.53-.58-5.29-.88a88.59,88.59,0,0,0-21.59-.06,123.66,123.66,0,0,0-21.54,4.34,208.36,208.36,0,0,0-41.07,17.42c-6.56,3.63-13.08,7.41-19.4,11.52s-12.53,8.46-18.47,13l0,0a1.76,1.76,0,0,1-2.29-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838.07,1154.72s-108.06,131-214.48,70.59c-98.92-56.15-122-140.7-208.14-136.18a13.2,13.2,0,0,1-12.51-18.86c17-35.71,64.77-102.91,182-97.69C744,979.67,838.07,1154.72,838.07,1154.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M826.39,1153.5c-8.63,2.39-17.27,2.6-25.93,2.3a148.62,148.62,0,0,1-25.67-3.26,247.94,247.94,0,0,1-49-16.06L714,1131.14l-11.43-5.93c-3.85-1.91-7.53-4.11-11.24-6.26s-7.44-4.27-11.11-6.48c-14.54-9-28.67-18.66-42.54-28.53s-27.5-20-41.59-29.2-28.63-17.74-44.48-22.51a89.65,89.65,0,0,0-24.31-3.93,96.92,96.92,0,0,0-24.57,2.87c-16.2,4-31.31,12-45.66,20.84h0a1.09,1.09,0,0,1-1.2-1.81c13.92-9.82,29-18.47,45.7-23.39a93.32,93.32,0,0,1,25.78-3.9,95.11,95.11,0,0,1,25.94,3.5c16.9,4.66,32.29,13.06,46.74,22.2s28.31,19.14,42.23,28.83c27.73,19.5,56.15,37.85,86.67,52a280.91,280.91,0,0,0,47.19,17.14,175.13,175.13,0,0,0,24.64,4.56,111.08,111.08,0,0,0,12.49.67,67.2,67.2,0,0,0,12.3-1l.17,0a1.4,1.4,0,0,1,1.64,1.11A1.42,1.42,0,0,1,826.39,1153.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1633.91,758.63c0,283.65-229.94,513.59-513.59,513.59S594,1032.23,594,748.58,836.68,245,1120.32,245,1633.91,475,1633.91,758.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M634.35,631.33a1,1,0,0,1-.29,0,1.13,1.13,0,0,1-.8-1.37,460.61,460.61,0,0,1,20.88-60.87,1.12,1.12,0,0,1,1.47-.6,1.14,1.14,0,0,1,.6,1.48,458.94,458.94,0,0,0-20.77,60.57A1.12,1.12,0,0,1,634.35,631.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M712.84,470.84a1.18,1.18,0,0,1-.68-.23,1.14,1.14,0,0,1-.22-1.58C806.64,343.45,959.19,268.48,1120,268.48a486.68,486.68,0,0,1,197.4,41.37,1.13,1.13,0,0,1-.91,2.07A484.3,484.3,0,0,0,1120,270.73c-160.13,0-312,74.64-406.28,199.66A1.14,1.14,0,0,1,712.84,470.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1564,758.63c0,245.53-199,444.56-444.56,444.56S663.91,995.46,663.91,749.93s210-435.87,455.56-435.87S1564,513.1,1564,758.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1564,758.63c0-245.53-199-444.57-444.56-444.57-133,0-255.48,55.84-339.91,146L1122,745l70.4,452.19C1403.24,1162.39,1564,979.3,1564,758.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1503.52,727.72c0,221.59-183.36,401.22-409.54,401.22S674.3,941.46,674.3,719.88,867.79,326.51,1094,326.51,1503.52,506.14,1503.52,727.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M777.52,735.57a34.23,34.23,0,1,1-32.18-36.16A34.23,34.23,0,0,1,777.52,735.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1517,778.61a34.23,34.23,0,1,1-32.19-36.16A34.23,34.23,0,0,1,1517,778.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1052.68,1085.76a34.23,34.23,0,1,1-39.82,27.52A34.23,34.23,0,0,1,1052.68,1085.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1185.77,357.11A34.23,34.23,0,1,1,1146,384.63,34.24,34.24,0,0,1,1185.77,357.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1296,1105.32c3.48,8.77,2.61,17-1.94,18.35s-11.06-4.65-14.54-13.42-2.61-17,1.94-18.36S1292.53,1096.54,1296,1105.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M998.53,414.2c3.48,8.77,2.61,17-1.94,18.35s-11.06-4.65-14.54-13.42-2.61-17,1.94-18.36S995.05,405.42,998.53,414.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1451.33,973.94c7.53,5.69,11.06,13.17,7.87,16.69s-11.86,1.77-19.39-3.92-11-13.17-7.87-16.7S1443.81,968.25,1451.33,973.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M838.25,537.74c7.53,5.69,11,13.17,7.87,16.69s-11.86,1.77-19.39-3.92-11.06-13.17-7.87-16.7S830.72,532.05,838.25,537.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1470.84,582.62c8.53-4.06,16.78-3.74,18.44.71s-3.89,11.34-12.42,15.4-16.78,3.74-18.44-.71S1462.32,586.67,1470.84,582.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M801.2,925.72c8.52-4.06,16.78-3.74,18.44.7s-3.9,11.35-12.42,15.41-16.78,3.74-18.44-.71S792.68,929.77,801.2,925.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1329.36,436.44c5.17-7.89,12.39-11.91,16.12-9s2.56,11.72-2.61,19.61-12.4,11.91-16.13,9S1324.18,444.33,1329.36,436.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M935.2,1077.36c5.17-7.89,12.39-11.91,16.12-9s2.56,11.72-2.61,19.61-12.4,11.91-16.13,9S930,1085.25,935.2,1077.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1105.6,732.29,960.16,461.64a7.87,7.87,0,0,1,6.93-11.6h35.41a7.87,7.87,0,0,0,5.75-13.25l-181-193.37c-5.54-5.92-15.33-.61-13.39,7.25L876.3,504.93a7.87,7.87,0,0,0,13.41,3.48l28.63-30.86a7.87,7.87,0,0,1,12.47,1.22L1092,740.14a7.87,7.87,0,0,0,10.68,2.66h0A7.86,7.86,0,0,0,1105.6,732.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M881.12,471.09a1.13,1.13,0,0,1-1.11-1c-.34-2.14-18.45-75-48.45-194.91a4.36,4.36,0,0,1,7.51-3.93l37.28,42.39a1.13,1.13,0,1,1-1.69,1.49l-37.28-42.39a2.11,2.11,0,0,0-3.64,1.9c14.47,57.81,48.15,192.55,48.5,195.15a1.12,1.12,0,0,1-1,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1120,760.54l268.69-8.74a7.87,7.87,0,0,1,7.11,11.49l-16.29,31.44a7.87,7.87,0,0,0,9.12,11.2l255-71.77c7.8-2.19,7.59-13.32-.29-15.23l-254.48-61.51a7.87,7.87,0,0,0-9.26,10.31l14.23,39.62a7.87,7.87,0,0,1-6.82,10.51l-267.69,27a7.88,7.88,0,0,0-7.27,8.26h0A7.87,7.87,0,0,0,1120,760.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1558.35,745.49a1.13,1.13,0,0,1-.27-2.22l54.78-13.6a2.11,2.11,0,0,0,0-4.1c-58-13.75-193.12-45.83-195.59-46.71a1.12,1.12,0,0,1,.75-2.12c3,1,150.29,36,195.36,46.64a4.36,4.36,0,0,1,0,8.48l-54.78,13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1153.73,745.76a36.56,36.56,0,1,1-36.56-36.55A36.56,36.56,0,0,1,1153.73,745.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2034.41,868.54c19.94-21,30.28-48.88,30.28-77.86V726.1l-164.33-4.93L1736,726.1v64.58c0,29,9.81,56.84,29.75,77.86L1850,958a23.91,23.91,0,0,1-.32,32.91L1766,1080.41c-19.94,21-29.92,48.88-29.92,77.85v64.59l164.32,4.93,164.33-4.93v-64.59c0-29-10.34-56.83-30.28-77.85l-84.5-89.48a23.91,23.91,0,0,1-.2-32.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1977.12,1057.52s-43.57-31.51-50.13-83c6.56-51.53,50.13-83,50.13-83,105.23-74,65.9-165.32,65.9-165.32l-143.59-4.94-142.9,4.94s-39,91.36,66.25,165.32c0,0,43.86,31.51,50.46,83-6.6,51.54-50.46,83-50.46,83-105.23,74-66.25,165.32-66.25,165.32l142.9,4.94,143.59-4.94S2082.35,1131.48,1977.12,1057.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1869.3,910.88a57.41,57.41,0,0,1,22.93,28.71c.28.78.55,2.23.79,3,1,3,3.78,5.77,7,5.77h.09c5,0,9.48-3.92,11.23-8.6a56.59,56.59,0,0,1,22.29-27.7c76.9-50.09,92-101,92-101H1777.82S1792.83,860.93,1869.3,910.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1934.71,1122.9a61.63,61.63,0,0,1-23.29-29.16c-.54-1.39-1-3-1.47-4.36a8.12,8.12,0,0,0-7.62-5.7,12.34,12.34,0,0,0-11.63,8c-4.5,12.14-12.78,23.5-23.63,30.57-80.81,52.69-96.65,107.45-96.65,107.45h260.7S2015.31,1175.5,1934.71,1122.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1906.78,968.23a6.24,6.24,0,1,1-6.24-6.24A6.24,6.24,0,0,1,1906.78,968.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1914.64,1011a4.63,4.63,0,1,1-4.63-4.62A4.62,4.62,0,0,1,1914.64,1011Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1896.15,1044.27a4.63,4.63,0,1,1-4.63-4.62A4.62,4.62,0,0,1,1896.15,1044.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1704.52,
    y: 693.99,
    width: 391.68,
    height: 47.27,
    rx: 22.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1704.52,
    y: 1218.48,
    width: 391.68,
    height: 47.27,
    rx: 22.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.24,1127.81c-3.61,5.32-17.92,126-20.16,170.51a5.28,5.28,0,0,0,5.28,5.53h0a5.29,5.29,0,0,0,5.22-4.47l26.17-167.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.29,1127.81c3.6,5.32,17.91,126,20.15,170.51a5.28,5.28,0,0,1-5.27,5.53h0a5.29,5.29,0,0,1-5.22-4.47l-26.17-167.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M242.59,1118.39v1.32c-.09,9.46,8.06,17.22,18.27,17.4l121,2.06c10.06.17,18.45-7.11,18.93-16.42l.07-1.21c.51-9.71-7.75-17.9-18.24-18.09l-121-2.17C251.21,1101.1,242.68,1108.79,242.59,1118.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M478,1293.94c-21.5,0-31-1.85-35.27-3.53a8.15,8.15,0,0,0,7.94,6.32h76.09a3.7,3.7,0,0,0,3.57-4.67C521.6,1292.76,503.18,1293.94,478,1293.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M530.28,1292.06a3.73,3.73,0,0,0-.63-1.3c-5.79-7.4-17.43-19-33.27-18.79-23.2.32-31.29,2.84-49.32.14l-4.25,14.1a7.92,7.92,0,0,0-.13,4.2c4.25,1.68,13.77,3.53,35.27,3.53C503.18,1293.94,521.6,1292.76,530.28,1292.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M452.28,1256.91l-5.22,17.76s11.57,5.27,21.74,1l2-15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610,1282.76c-16.77,13.47-25.34,18-29.7,19.36a8.15,8.15,0,0,0,10.13-.08l59.31-47.66a3.69,3.69,0,0,0-.13-5.86C643.26,1254.5,629.64,1267,610,1282.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M649.59,1248.52a3.76,3.76,0,0,0-1.29-.61c-9.13-2.11-25.45-3.83-37.66,6.26-17.88,14.78-22.62,21.8-38.36,31l5.47,13.6a8,8,0,0,0,2.53,3.35c4.36-1.36,12.93-5.89,29.7-19.36C629.64,1267,643.26,1254.5,649.59,1248.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.6,1054.61s128.76,10.51,155.17,23-21.55,186.71-21.55,186.71-7.19,3.46-23.2-1.51c0,0,16.41-128.61,4.2-156.5l-139.41-22.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M559.49,1260.69c1.19,1.09,12.79,24.48,12.79,24.48s12.91-2.79,15.55-11l-11.62-21.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263,1053.53a65.34,65.34,0,0,0-4,23.52c.23,18.55,15.15,33.61,33.69,34.54l152.21,6.94a7.28,7.28,0,0,1,6.74,5.48c3.58,13.84,21.07,56.33,106.53,141.11a6.89,6.89,0,0,0,8.52.93l12.17-7.69a2.79,2.79,0,0,0,.92-3.78l-88.63-151.35a34.33,34.33,0,0,0-20.84-15.46L340.6,1054.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M439.63,820.51s-42.88,25.44-59.51,39.4l34.36,19.18s18.57-21.45,36.26-30.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.28,1054.61s41.09,10,80.32,0c0,0,54.88-73.78,76.11-93.86,0,0,33.87,53.44,109.26,61l4.21-9.4s-60-27.66-78.5-70.17-25.89-60.65-42.7-71.74c-10.47-6.9-16.74-11.62-20-14.2a5.38,5.38,0,0,0-6.16-.39C365,866.74,281.07,924.23,260.28,1054.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M414.49,958.83a1.77,1.77,0,0,1-1.4-.69c-13-17-20.48-36.25-20.55-36.44a1.75,1.75,0,1,1,3.27-1.26c.08.19,7.38,19,20.07,35.56a1.75,1.75,0,0,1-.33,2.46A1.71,1.71,0,0,1,414.49,958.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M521.44,1007.47l8.49-2.27,25.76-6a12,12,0,0,1,9.06,1.52l22.15,13.94-61.18-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M481.49,801.86c.12.83-11,55.23-11,55.23l-30.93-7L442.44,797S479.48,787.94,481.49,801.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M449.4,808.81l-3.7,27.84a3.84,3.84,0,0,0,0,1.07c.31,2.18,1.94,9.62,9.44,7.49,6.81-1.93,13.05-3.59,17.36-2.27a3.93,3.93,0,0,1,2.7,4.54,169.26,169.26,0,0,1-7.12,25.35,3.91,3.91,0,0,1-4.75,2.31c-5.87-1.71-18.14-5.66-27.27-11.15a3.94,3.94,0,0,1-1.91-3.53c.3-7,1.12-28.41.43-34.4-.65-5.62-7.55-9-10.55-10.2a3.88,3.88,0,0,1-2.15-2.15c-1.38-3.48-3.3-11.53,6.85-14.83a3.94,3.94,0,0,0,2.49-5.08c-1.51-4.19-2.14-10.57,5.71-14.09s13.93.68,17.15,4.14a3.93,3.93,0,0,0,5,.59,3.1,3.1,0,0,1,3.54.12,3.86,3.86,0,0,0,5.47-1.66c1.91-3.92,5.81-8.13,13.62-6.79,13.86,2.38,15.43,17.73,11.77,26.73s-18.54,5.58-26,1c-5.68-3.45-13,.17-16.24,2.1A3.85,3.85,0,0,0,449.4,808.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M433.33,836.22s5.7-16-.15-19.87-14.53-1.88-12.62,9.68C422.94,840.41,433.33,836.22,433.33,836.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M497.8,1026.7h.3l130.7-.13a5.84,5.84,0,1,0,0-11.68l-130.69.13a5.84,5.84,0,0,0-.29,11.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M679.41,898.71l-.13.27-55,118.56a5.84,5.84,0,1,0,10.59,4.91l55-118.56a5.84,5.84,0,0,0-10.46-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M556,1033.26c-.57,2.37-55.11,206.89-68.93,258.74a9.37,9.37,0,0,0,9,11.85h0a9.31,9.31,0,0,0,9-7.13l60.54-245.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M585.86,1033.26c.57,2.37,55.1,206.89,68.93,258.74a9.38,9.38,0,0,1-9,11.85h0a9.32,9.32,0,0,1-9-7.13l-60.53-245.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M588.13,1026.57h-34v27.28a7.06,7.06,0,0,0,7,7.1h4.66v61.26a5.35,5.35,0,0,0,5.31,5.38h0a5.35,5.35,0,0,0,5.31-5.38V1061h2.36a9.37,9.37,0,0,0,9.31-9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470.66,1020H660.3a5.83,5.83,0,0,1,5.63,4.42l2.65,10.38a5.87,5.87,0,0,1-5.66,7.35L468.32,1041a5.87,5.87,0,0,1-5.6-7.32l2.3-9.25A5.83,5.83,0,0,1,470.66,1020Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.57,752.14a5.93,5.93,0,0,1-4.51-2.09l-18.71-22.13a137,137,0,0,1-40.89-.91l-19.68,21.24a5.9,5.9,0,0,1-6.72,1.39l-33.83-14.92a5.91,5.91,0,0,1-3.5-5.89L137.14,700a137.17,137.17,0,0,1-28.25-29.57l-28.95,1.1a5.93,5.93,0,0,1-5.74-3.77L60.83,633.26a5.92,5.92,0,0,1,1.69-6.65L84.64,607.9A137.63,137.63,0,0,1,85.55,567L64.32,547.34a5.93,5.93,0,0,1-1.4-6.72l14.92-33.83a5.93,5.93,0,0,1,5.89-3.51l28.86,2.41a137.69,137.69,0,0,1,29.58-28.25l-1.1-28.95a5.9,5.9,0,0,1,3.76-5.73l34.47-13.37a5.92,5.92,0,0,1,6.65,1.69l18.71,22.12a137.36,137.36,0,0,1,40.89.91l19.68-21.24a5.92,5.92,0,0,1,6.72-1.39l33.83,14.92a5.9,5.9,0,0,1,3.5,5.9l-2.4,28.85a137.6,137.6,0,0,1,28.24,29.57l28.95-1.1a6,6,0,0,1,5.74,3.77l13.37,34.47a5.92,5.92,0,0,1-1.69,6.65l-22.12,18.71a137.36,137.36,0,0,1-.91,40.89l21.24,19.68a5.9,5.9,0,0,1,1.38,6.72l-14.91,33.83a6,6,0,0,1-5.9,3.5l-28.85-2.41a137.45,137.45,0,0,1-29.58,28.25l1.1,29a5.9,5.9,0,0,1-3.76,5.73l-34.47,13.38A5.92,5.92,0,0,1,262.57,752.14ZM242.1,720.73l20.73,24.49,33.34-12.93L295,700.22l1.54-1.05a130.71,130.71,0,0,0,30.67-29.29l1.12-1.49,32,2.67,14.43-32.73-23.52-21.79.35-1.84a130.5,130.5,0,0,0,.94-42.39l-.26-1.85,24.5-20.72-12.94-33.35-32.06,1.22-1.05-1.53a130.91,130.91,0,0,0-29.29-30.67l-1.49-1.12,2.66-32L269.78,437.9,248,461.42l-1.83-.34a130.85,130.85,0,0,0-42.4-.95l-1.84.26L181.18,435.9l-33.34,12.94,1.22,32.06L147.52,482a130.71,130.71,0,0,0-30.67,29.29l-1.12,1.49-31.95-2.67L69.35,542.79l23.52,21.8-.35,1.83a130.79,130.79,0,0,0-.94,42.39l.26,1.85-24.5,20.72,12.94,33.35,32.06-1.22,1,1.54a130.71,130.71,0,0,0,29.3,30.66l1.48,1.12-2.66,32,32.72,14.43L196,719.7l1.83.34a130.85,130.85,0,0,0,42.4,1Zm-20.93-37.24A92.56,92.56,0,1,1,275.75,516a3.38,3.38,0,1,1-4,5.46,87.22,87.22,0,0,0-15.85-9.1,85.81,85.81,0,1,0,50.56,67.94,3.38,3.38,0,0,1,6.7-.84,92.61,92.61,0,0,1-92,104Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222,626.77a36.81,36.81,0,0,1-6.09-.51,36.21,36.21,0,0,1,6-71.91,36.21,36.21,0,0,1,35.73,42.27A36.09,36.09,0,0,1,222,626.77ZM222,561.1a29.51,29.51,0,1,0,5,.42A30.65,30.65,0,0,0,222,561.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.61,487.44a3,3,0,0,1-.89-.13l-10.44-3.24a3,3,0,0,1-2.11-2.77l-.25-7.89a41.84,41.84,0,0,1-8.54-7.09l-7.8,1.2a3,3,0,0,1-3.1-1.57l-5.1-9.67a3,3,0,0,1,.47-3.45l5.4-5.75a42,42,0,0,1-1-11.06l-6.36-4.67a3,3,0,0,1-1.1-3.31L371,417.61a3,3,0,0,1,2.78-2.12l7.88-.24a41.62,41.62,0,0,1,7.1-8.55l-1.2-7.79a3,3,0,0,1,1.56-3.11l9.67-5.09a3,3,0,0,1,3.46.47l5.74,5.39a41.55,41.55,0,0,1,11.06-1l4.67-6.37A3,3,0,0,1,427,388.1l10.44,3.24a3,3,0,0,1,2.11,2.77l.24,7.89a41.9,41.9,0,0,1,8.55,7.09l7.79-1.2a3,3,0,0,1,3.11,1.57l5.09,9.67a3,3,0,0,1-.46,3.45l-5.4,5.75a41.47,41.47,0,0,1,1,11.06l6.37,4.67a3,3,0,0,1,1.09,3.31l-3.24,10.43a3,3,0,0,1-2.76,2.11l-7.9.25A41.84,41.84,0,0,1,446,468.7l1.2,7.8a3,3,0,0,1-1.56,3.11L436,484.7a3,3,0,0,1-3.46-.48l-5.74-5.39a41.07,41.07,0,0,1-11.06,1L411,486.22A3,3,0,0,1,408.61,487.44Zm-9-7.35,8.4,2.6,5.49-7.49,1.24.09a37.79,37.79,0,0,0,12.08-1.11l1.2-.31,6.76,6.35,7.78-4.1L441.16,467l.94-.81a37.4,37.4,0,0,0,7.75-9.33l.63-1.07,9.28-.29,2.6-8.4-7.48-5.49.08-1.24a37.23,37.23,0,0,0-1.11-12.08l-.31-1.2,6.35-6.76-4.09-7.77-9.17,1.41-.82-.94a37,37,0,0,0-9.33-7.75l-1.07-.63-.29-9.28-8.4-2.6-5.48,7.48-1.24-.08a37.21,37.21,0,0,0-12.08,1.11l-1.2.31L400,395.19l-7.77,4.09,1.41,9.17-.94.82a37.25,37.25,0,0,0-7.75,9.33l-.63,1.07L375,420l-2.6,8.39,7.49,5.49-.09,1.24a37.48,37.48,0,0,0,1.11,12.08l.31,1.21-6.35,6.76,4.1,7.77,9.17-1.41.81.94a37.61,37.61,0,0,0,9.33,7.75l1.07.63Zm17.55-13.8a28.63,28.63,0,1,1,25.3-42,28.94,28.94,0,0,1,2.25,5.65,2.25,2.25,0,1,1-4.34,1.22,24.12,24.12,0,1,0-44.58,17.7,24.14,24.14,0,0,0,41.95,1.31,2.25,2.25,0,0,1,3.84,2.34,28.67,28.67,0,0,1-24.42,13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M417.38,449.66a12,12,0,0,1-11.94-12.6,12,12,0,0,1,11.93-11.31,12,12,0,1,1,0,23.91Zm0-19.41a7.45,7.45,0,0,0-5.54,12.43,7.67,7.67,0,0,0,10.53.57,7.46,7.46,0,0,0-5-13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1794.71,
    y: 1144.3,
    width: 10.93,
    height: 118.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1755.46,1257.63h89.42a3.14,3.14,0,0,1,3.14,3.14v4a0,0,0,0,1,0,0h-95.7a0,0,0,0,1,0,0v-4A3.14,3.14,0,0,1,1755.46,1257.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1741.9,
    y: 1117.82,
    width: 120.33,
    height: 34.13,
    rx: 11.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1719.5,1065.51s-16.24,2.52-34.49,14.72a9.12,9.12,0,0,0-4,8.7c2.19,17.31,11.18,73.36,40.81,128.09a13.76,13.76,0,0,1,1.33,9.46l-5.15,24-9.55,9H1733l16.38-44.32-7-2.22a13.25,13.25,0,0,1-9.26-12.4l-.82-47.54c.7-21.18-13-35.79-13-35.79l39.28-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1699.13,1260.39c-2.22,2.74,24,6.35,37.22.36,0,0,18.35-30,18.35-45.46,0,0-1.46-3.15-12.23-2.43,0,0-6.17,35.53-12.67,39.51s-18.2.4-18.2.4S1702.42,1256.34,1699.13,1260.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1753.65,1117.82c-.21-.36-42.29-5.06-42.29-5.06s1.37,12.8-2.93,30.41-66.09,93.93-66.09,93.93l6.48,20.53c-20,7-39.74,8.1-59.12,3.56l40.14-24.09s37.58-128,60.59-150.9l42.19-14.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1848,1043.32s24.25,36.06,26.24,52.51-6.65,23.13-32.09,24.23-93.35,1.09-93.35,1.09l-58-49.54s42.24-15.07,53.22-19.33S1848,1043.32,1848,1043.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1646.37,1250.72s7,6.75,2.26,14.27c0,0-55.25,9.79-70.25,5.35,0,0,3.11-7.11,20-15.2l-1.25.95a2,2,0,0,0,1.33,3.62C1609.6,1259.08,1632.64,1257,1646.37,1250.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1782.45,1038.54s-28.23-26.88-42.13-44.69a37.8,37.8,0,0,1-6.4-34c6.35-21.38,17.62-43.52,18.65-47,1.58-5.28,33.24-5.06,33.24-5.06s62.29,40.43,86.77,108.92l-27.49,8.56s-16.27-27.29-32.34-44.64c0,0,27.81,36.74,28.79,51.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1748.74,883.36c.33,1.1,8.6,28.5,9.24,29.06s18.12,1.51,26.35-4.11L1767.83,869Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1713.16,860.33s-4.72,15.49,5.32,37.09,22.54,22.16,29.69,15.73,16.1-17.48,15.06-38S1719.85,840.66,1713.16,860.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1747.91,875.58s-17-28.85-35.2-7.62l-.69,8s-20-3.33-15.61-21.61,26.19-32.8,48.2-23.76,30.56,21.64,31.25,37.75-11.9,12-11.9,12-3.63-11.49-9.5-12.94-4.73,7.43-4.73,7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1752.62,875.43s-8.83-14.78,1-16.46,7.57,14.35,6.24,20.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1724.93,1040.54l20.75-20,28.69,12.13s28.57,4.42,44.92,0l16.34-4.43,36.95-11.5,5.8,16.4a9.88,9.88,0,0,1-3.61,11.34,64.41,64.41,0,0,1-9.33,5.81c-4.86,2.13-119.93-1.47-119.93-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1745.93,834.55c-5.12.41-8.39-5.36-5.74-9.77,8.54-14.22,26.56-31.73,60.22-17.31,37.92,16.26,58,23,65.75,19.17,5.07-2.52,10.81,1.84,9.28,7.29-1.13,4-4.17,8.62-10.51,13.53C1816,885.31,1776,832.17,1745.93,834.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1803.43,1050h-.27l-120.33-.13a5.39,5.39,0,1,1,0-10.77l120.33.13a5.38,5.38,0,0,1,.26,10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1574.65,940.71h100.22a19.1,19.1,0,0,1,17.27,10.95l46.33,98.24H1613.93a11.6,11.6,0,0,1-10.79-7.34l-35.93-90.91A8,8,0,0,1,1574.65,940.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1645.25,991.08c2.18,6.75.57,13.3-3.58,14.63s-9.27-3.05-11.45-9.79-.56-13.3,3.59-14.64S1643.08,984.33,1645.25,991.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1971.62,1054.36a4.44,4.44,0,0,0-1-3.85,5.09,5.09,0,0,0-3.83-1.69H1464.6a5.8,5.8,0,0,0-4.81,2.47,5.06,5.06,0,0,0-.37,5.13l5.44,11a7.65,7.65,0,0,0,6.91,4.15H1963.3a5.68,5.68,0,0,0,5.66-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1492.75,1287a4.32,4.32,0,0,1-1.74-.37,4.56,4.56,0,0,1-2.31-5.93l92.42-219.81a4.37,4.37,0,0,1,5.79-2.36,4.54,4.54,0,0,1,2.31,5.92l-92.42,219.82A4.42,4.42,0,0,1,1492.75,1287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1596.86,1287a4.42,4.42,0,0,1-4-2.73l-92.42-219.82a4.54,4.54,0,0,1,2.31-5.92,4.36,4.36,0,0,1,5.79,2.36l92.42,219.81a4.56,4.56,0,0,1-2.31,5.93A4.32,4.32,0,0,1,1596.86,1287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1856.68,1287a4.32,4.32,0,0,1-1.74-.37,4.55,4.55,0,0,1-2.3-5.93l92.41-219.81a4.38,4.38,0,0,1,5.79-2.36,4.54,4.54,0,0,1,2.31,5.92l-92.42,219.82A4.42,4.42,0,0,1,1856.68,1287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1960.8,1287a4.43,4.43,0,0,1-4.06-2.73l-92.41-219.82a4.54,4.54,0,0,1,2.3-5.92,4.36,4.36,0,0,1,5.79,2.36l92.42,219.81a4.56,4.56,0,0,1-2.31,5.93A4.24,4.24,0,0,1,1960.8,1287Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1277.64,117.91a5.76,5.76,0,0,1,1.84.89c.92.7,1.87,2,3.09,2.9a43.31,43.31,0,0,1,4.29,3.78l0,0c.75.61,1.26,1.27.63,2.1a1.59,1.59,0,0,1-2.37.23s-2.21-1.86-4.52-3.6c-.57-.44-1.1-.94-1.63-1.36s-.83-.69-1.19-1a8.38,8.38,0,0,0-.85-.72l-.4-.28-.65-.46a1.51,1.51,0,0,1-.55-2.23,1.48,1.48,0,0,1,2.27-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1296.94,131.14l9.68,6.24a1.78,1.78,0,0,1,.41,2.51,1.85,1.85,0,0,1-2.5.62l-9.69-6.23a1.79,1.79,0,0,1-.42-2.52,1.84,1.84,0,0,1,2.51-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1316.08,144.32l10.37,4.82a1.45,1.45,0,0,1,.7,2.14,1.75,1.75,0,0,1-2.4.66l-10.18-5.47c-.85-.44-1.29-1-.78-1.89s1.39-.26,2.29-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1336.36,156l11,3.2c.88.37,1.38.78,1,1.7a1.66,1.66,0,0,1-2.3.69L1335.34,157c-.88-.37-1.52-.23-1.09-1.16s1.24.18,2.11.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1359,158.24l10.82,5.15c.91.28,1.22,2.16.88,3.11s-1.43,1.93-2.34,1.66L1357.17,165c-.91-.28-1.09-2.94-.75-3.89s1.73-2.9,2.56-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1380.88,169.49l11.42,1.26c.93.17,1.45.68,1.21,1.65a1.8,1.8,0,0,1-2.15,1.24l-11.54-2.16c-.94-.16-1.4-.33-1.17-1.29s1.44-.7,2.23-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1404.91,169.49l11.19,1.43c1,0,1.31,1.3,1.2,2.27a2.28,2.28,0,0,1-2.09,1.9l-11.89-.42c-1,0-1-1.69-.93-2.67s.11-.25,2.51-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1427,171.75l12-1.26a1.54,1.54,0,0,1,1.77,1.49,1.84,1.84,0,0,1-1.68,1.84l-11.89,1.06a1.51,1.51,0,0,1-1.81-1.41,1.66,1.66,0,0,1,1.63-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1450.5,169.49l12.07-1.76a1.55,1.55,0,0,1,1.87,1.38,1.8,1.8,0,0,1-1.56,1.88L1451,172.51a1.57,1.57,0,0,1-2-1.29c0-.95.94-2.15,1.44-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1474.26,167.24l11.94-3.07c.93-.18,1.83,0,1.93,1a1.64,1.64,0,0,1-1.45,1.81l-11.8,2.19c-.93.18-1.89.32-2-.62s.62-1.27,1.38-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1497.91,160.49l11.66-3.32a1.56,1.56,0,0,1,2,1.18,1.86,1.86,0,0,1-1.29,2.13l-11.64,3.43a1.6,1.6,0,0,1-2-1.22c-.19-.91.38-2.2,1.28-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1520.79,153.74s2.8-1.57,5.59-2.83,5.32-2.92,5.32-2.92l.1-.14a1.55,1.55,0,0,1,2.19.66,1.79,1.79,0,0,1-.86,2.26s-2.8,1.44-5.6,2.9l-5.59,2.52c-.86.39-1.82.33-2.14-.52s.14-1.93,1-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1542.45,141.23a3.26,3.26,0,0,1,1-1.34c.43-.39.77-.87,1.22-1.36s.9-1,1.42-1.54a39.31,39.31,0,0,0,2.56-3.14c.66-.9,1.08-1.5,1.08-1.5l.07-.12a1.67,1.67,0,0,1,2.31-.45,1.63,1.63,0,0,1,.26,2.31l-1.21,1.65a42.38,42.38,0,0,1-2.87,3.44l-1.71,1.72c-.54.57-1,1-1.49,1.38l-1.46,1.29c-.71.63-1.33.66-1.9,0s.68-1.47.68-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1556,122.4a3.49,3.49,0,0,1-.51-2.2c.11-.58-.25-1.35-.21-2,0-.32-.16-.74-.13-1.08a1.86,1.86,0,0,0-.07-.43l-.08-.58c0-.36,0-.78-.09-1.1s-.12-.59-.17-.87c-.08-.56-.32-1.14-.43-1.61-.35-.94-.61-1.56-.61-1.56l0-.07a1.76,1.76,0,0,1,.89-2.23,1.52,1.52,0,0,1,2.12.72s.31.73.73,1.85a20,20,0,0,1,.53,2.05c.07.4.14.82.21,1.25s0,.76.07,1.14l0,.56c0,.46,0,.48,0,.73,0,.41-.06.8-.09,1.18a16,16,0,0,1-.23,2l-.3,1.88c-.15.92-.17,1.91-1.06,1.83s-.53-.77-.53-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1546.44,103.15a40,40,0,0,0-4.24-3.89c-2.36-1.42-4.57-3-4.57-3l-.07-.18a1.5,1.5,0,0,1-.29-2.18c.5-.79.52-1.92,2.38-.55h0s2.46,1.45,5,3l4.49,3.48c.68.53.45,1.89-.13,2.63s-1.94,1.25-2.61.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1527.47,90.71a2.55,2.55,0,0,1-1.85.39,17.13,17.13,0,0,0-1.84.09c-.64,0-1.32.09-2,0a16.51,16.51,0,0,0-2,.17,6.68,6.68,0,0,0-1.73.27c-1,.21-1.64.38-1.64.38l-.3.08a1.46,1.46,0,0,1-1.8-1.24,1.75,1.75,0,0,1,1.34-1.92l2-.46a8.78,8.78,0,0,1,2.07-.28,20.37,20.37,0,0,1,2.36-.08l2.34.16a15,15,0,0,1,1.9.28l1.81.31c.86.15,1.43.28,1.22,1.17s-1.07.64-1.91.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1510.93,98.8s-2.13.52-2.75,1.5c-.16.25-1.18.45-1.36.73s-.69.52-.83.82c-.26.58-.75,1.19-1,1.82s-.54,1.36-.74,2a16.65,16.65,0,0,0-.73,1.76,6.08,6.08,0,0,1-.62,1.74l0,.15a1.55,1.55,0,0,1-1.66,1.42,1.39,1.39,0,0,1-1.11-1.79s.22-.78.46-2a14.16,14.16,0,0,1,.52-2c.23-.74.49-1.51.73-2.29s.71-1.58,1-2.32a10.48,10.48,0,0,1,1-1.82l1-1.65c.5-.78,3.2-.92,3.94-.48s2.15,1.54,2.15,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1504.18,120.87a33.66,33.66,0,0,0,.06,5.93c.53,2.84.76,5.68.76,5.68l-.13.11a1.78,1.78,0,0,1-1.34,1.95,1.48,1.48,0,0,1-1.87-1.13s-.58-3-1.14-6c-.33-3-.68-5.94-.68-5.94-.1-.87,1.12-1.71,2-1.88s2.35.4,2.35,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1508.84,142.48a38.71,38.71,0,0,0,1.77,6c1.22,2.57,2.24,5.41,2.24,5.41l-.08.21a1.78,1.78,0,0,1-.81,2.22,1.48,1.48,0,0,1-2.1-.57s-1.3-2.67-2.58-5.36l-2.22-5.41a2.66,2.66,0,0,1,1.31-2.65c.8-.39,1.75.2,2.46.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1517.83,162.74l7,10a2,2,0,0,1-.28,2.52,1.41,1.41,0,0,1-2.09-.09l-6.68-9.34c-.48-.68-.54-2.26.16-2.8s2.22-2.59,1.92-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1532.49,183l7.83,7.93a1.34,1.34,0,0,1-.17,2,1.54,1.54,0,0,1-2.19-.07l-8-8.41c-.56-.6-.42-1.18.21-1.8s1.48.36,2.26.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1548.49,198.36l1.33,1.21,3,2.59,4.34,3.78a1.6,1.6,0,0,1-2.08,2.41l-4.34-3.77-3-2.62-1.34-1.21a1.61,1.61,0,0,1,2.13-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1565.93,213.22l9.08,7.07a1.59,1.59,0,0,1-2,2.49l-9.09-7.06a1.59,1.59,0,0,1,2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1584.24,227l9.52,6.48a1.47,1.47,0,0,1,.3,2.09,1.53,1.53,0,0,1-2.09.47l-9.53-6.47a1.49,1.49,0,0,1-.3-2.1,1.54,1.54,0,0,1,2.1-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1603.43,239.59l10,5.77a1.46,1.46,0,0,1,.44,2,1.54,1.54,0,0,1-2,.6l-10-5.75a1.46,1.46,0,0,1-.44-2.05,1.54,1.54,0,0,1,2-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1623.75,250.42l10.36,5a1.47,1.47,0,0,1,.54,2,1.59,1.59,0,0,1-2,.79l-10.49-4.89a1.53,1.53,0,0,1-.49-2.09c.38-.76,1.5-1.37,2.09-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1644.55,260.37l10.43,5a1.41,1.41,0,0,1,.57,2,1.52,1.52,0,0,1-2,.73l-10.43-5a1.41,1.41,0,0,1-.58-2,1.53,1.53,0,0,1,2-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1665.35,270.57l10.2,5.41a1.4,1.4,0,0,1,.49,2,1.5,1.5,0,0,1-2,.65l-10.21-5.39a1.41,1.41,0,0,1-.5-2,1.51,1.51,0,0,1,2-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1685.67,281.63l9.95,5.83a1.4,1.4,0,0,1,.4,2,1.48,1.48,0,0,1-2,.57l-10-5.83a1.39,1.39,0,0,1-.41-2,1.48,1.48,0,0,1,2-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1705.47,293.55l9.67,6.27a1.4,1.4,0,0,1,.32,2,1.46,1.46,0,0,1-2,.48l-9.67-6.26a1.41,1.41,0,0,1-.33-2,1.47,1.47,0,0,1,2-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1724.7,306.34l9.35,6.72a1.39,1.39,0,0,1,.24,2,1.43,1.43,0,0,1-2,.4l-9.37-6.7a1.4,1.4,0,0,1-.23-2,1.43,1.43,0,0,1,2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1743.29,320l9,7.16a1.45,1.45,0,0,1-1.8,2.26l-9-7.14a1.46,1.46,0,0,1,1.82-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1761.18,334.61l8.65,7.6a1.4,1.4,0,0,1,.05,2,1.38,1.38,0,0,1-1.94.2l-8.65-7.59a1.39,1.39,0,0,1,0-2,1.37,1.37,0,0,1,1.94-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1778.32,350.08l8.24,8a1.4,1.4,0,0,1,0,1.95,1.35,1.35,0,0,1-1.92.11l-8.25-8a1.4,1.4,0,0,1,0-1.95,1.36,1.36,0,0,1,1.93-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1794.63,366.44l7.8,8.48a1.39,1.39,0,0,1-.13,1.93,1.32,1.32,0,0,1-1.89,0l-7.81-8.47a1.4,1.4,0,0,1,.13-1.94,1.32,1.32,0,0,1,1.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1810.05,383.67l7.34,8.93a1.38,1.38,0,0,1-.23,1.9,1.29,1.29,0,0,1-1.86-.08L1808,385.5a1.38,1.38,0,0,1,.22-1.91,1.31,1.31,0,0,1,1.88.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1824.51,401.79l6.83,9.34A1.39,1.39,0,0,1,1831,413a1.27,1.27,0,0,1-1.83-.18l-6.83-9.34a1.4,1.4,0,0,1,.32-1.89,1.27,1.27,0,0,1,1.84.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1837.93,420.74l6.26,9.76a1.39,1.39,0,0,1-.42,1.85,1.25,1.25,0,0,1-1.79-.29l-6.28-9.75a1.38,1.38,0,0,1,.43-1.85,1.25,1.25,0,0,1,1.8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1850.2,440.52l2.85,5.07c.7,1.25,1.44,2.55,2,3.51l.86,1.6a1.38,1.38,0,0,1-.54,1.8,1.22,1.22,0,0,1-1.74-.41l-.86-1.6c-.51-1-1.21-2.19-1.93-3.47l-2.86-5.07a1.37,1.37,0,0,1,.51-1.81,1.23,1.23,0,0,1,1.76.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1861.21,461.12l5,10.56a1.39,1.39,0,0,1-.63,1.76,1.2,1.2,0,0,1-1.68-.5l-5-10.55a1.4,1.4,0,0,1,.63-1.77,1.21,1.21,0,0,1,1.7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1870.84,482.49l4.25,10.93a1.37,1.37,0,0,1-.72,1.7,1.18,1.18,0,0,1-1.63-.61l-4.26-10.91a1.39,1.39,0,0,1,.73-1.72,1.18,1.18,0,0,1,1.63.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1879,504.6l3.44,11.27a1.35,1.35,0,0,1-.83,1.63,1.14,1.14,0,0,1-1.55-.71l-3.45-11.27a1.37,1.37,0,0,1,.83-1.64,1.16,1.16,0,0,1,1.56.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1885.44,527.39,1888,539a1.37,1.37,0,0,1-.94,1.56,1.14,1.14,0,0,1-1.47-.84L1883,528.11a1.37,1.37,0,0,1,.94-1.56,1.14,1.14,0,0,1,1.48.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1890.07,550.77l1.57,11.82a1.34,1.34,0,0,1-1,1.46,1.11,1.11,0,0,1-1.37-.95l-1.58-11.82a1.35,1.35,0,0,1,1-1.47,1.11,1.11,0,0,1,1.37,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1892.7,574.62l.51,12a1.33,1.33,0,0,1-1.15,1.36,1.1,1.1,0,0,1-1.25-1.06l-.52-12a1.34,1.34,0,0,1,1.15-1.37,1.09,1.09,0,0,1,1.26,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1893.15,598.79l-.49,10a1.32,1.32,0,0,1-1.25,1.24,1.09,1.09,0,0,1-1.13-1.17l.49-10a1.32,1.32,0,0,1,1.25-1.25,1.09,1.09,0,0,1,1.13,1.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1260.03 75.1 1255.11 115.69 1229.73 94.91 1260.03 75.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1080.32,29.68l98,109.44a10.33,10.33,0,0,0,14.89.54l106.18-102.5a4.15,4.15,0,0,0-2.88-7.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1260.01 75.1 1080.32 29.68 1242.93 91.7 1242.05 103.01 1260.01 75.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1232.73 101.46 1255.11 115.69 1242.93 91.7 1232.73 101.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1537,493.44c31,11.32,106.16,31,205.48,4.6a14.6,14.6,0,0,1,16.84,7.53c9.15,18.3,27.44,56.11,35.92,82.39a13.63,13.63,0,0,1-10.07,17.56c-39.55,8.53-155.6,26-240.06-38.34a21.89,21.89,0,0,1-8-12.5l-11.75-50.9A8.87,8.87,0,0,1,1537,493.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1651.31,601.63a3.55,3.55,0,0,1-3.34-2.35l-25.69-71.54a3.55,3.55,0,0,1,6.69-2.4l25.69,71.54a3.56,3.56,0,0,1-3.35,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1689.53,608.6a3.57,3.57,0,0,1-3.2-2l-38.21-79a3.55,3.55,0,1,1,6.39-3.1l38.22,79a3.56,3.56,0,0,1-3.2,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1715.69,608a3.54,3.54,0,0,1-3.22-2.06l-38.32-83.06a3.55,3.55,0,0,1,6.45-3l38.32,83.06a3.54,3.54,0,0,1-3.23,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1736.22,603.42a3.57,3.57,0,0,1-3.37-2.41l-28.22-82.9a3.55,3.55,0,0,1,6.72-2.29l28.23,82.9a3.55,3.55,0,0,1-2.22,4.51A3.5,3.5,0,0,1,1736.22,603.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1765.12,601.63a3.55,3.55,0,0,1-3.32-2.29L1728,510.12a3.55,3.55,0,0,1,6.64-2.52l33.83,89.22a3.55,3.55,0,0,1-2.06,4.58A3.46,3.46,0,0,1,1765.12,601.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1843.43,520.1l30.48,62.2a12.26,12.26,0,0,0,12.53,6.76c29.75-3.68,129.36-20.42,206.23-85.58a16.55,16.55,0,0,0,5-17.69l-37.1-115.38a14.85,14.85,0,0,0-18.52-9.68c-22.35,7-67,26.42-105.33,77.08-23.37,30.92-64.5,52.48-86.07,62.27A14.81,14.81,0,0,0,1843.43,520.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1953.75,563.49a3.56,3.56,0,0,1-3.16-1.93l-40.85-79.31a3.55,3.55,0,0,1,6.31-3.25l40.85,79.31a3.56,3.56,0,0,1-3.15,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1981,557a3.55,3.55,0,0,1-3.1-1.81L1927.68,466a3.55,3.55,0,0,1,6.19-3.49l50.23,89.24a3.56,3.56,0,0,1-1.35,4.84A3.64,3.64,0,0,1,1981,557Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M2003.59,544.83a3.56,3.56,0,0,1-3.28-2.17l-22.13-52.38a3.55,3.55,0,1,1,6.54-2.77l22.14,52.39a3.55,3.55,0,0,1-3.27,4.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M2033.23,526.4a3.56,3.56,0,0,1-3.31-2.26l-44.5-114.5a3.55,3.55,0,0,1,6.62-2.57l44.5,114.49a3.55,3.55,0,0,1-2,4.6A3.64,3.64,0,0,1,2033.23,526.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2051,514.25a3.54,3.54,0,0,1-3.4-2.57l-36.22-125a3.55,3.55,0,0,1,6.82-2l36.22,125a3.56,3.56,0,0,1-2.43,4.4A3.7,3.7,0,0,1,2051,514.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1988.64,498.48c8.61,14.77,26.86,48.08,28.36,67.09a6.59,6.59,0,0,0,6.09,6.09c30,2.2,161,6.3,218.78-83.28a6.57,6.57,0,0,0,.73-5.49c-5.33-17.17-33.67-106-64.73-154.25a6.59,6.59,0,0,0-10.91-.22c-21.47,30.07-102.48,138-174.56,160.45A6.58,6.58,0,0,0,1988.64,498.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M2213.74,496.43a3.55,3.55,0,0,1-3.52-3.12c-5.87-48-51.79-120.5-52.25-121.23a3.55,3.55,0,0,1,6-3.81c1.93,3,47.25,74.53,53.31,124.18a3.55,3.55,0,0,1-3.09,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M2192.86,505.7a3.55,3.55,0,0,1-3.47-2.8c-7.5-34.72-46.94-109.94-47.34-110.69a3.55,3.55,0,1,1,6.28-3.31c1.64,3.12,40.29,76.83,48,112.5a3.56,3.56,0,0,1-2.72,4.22A4,4,0,0,1,2192.86,505.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M2173.07,522.09a3.56,3.56,0,0,1-3.25-2.11l-16.5-37a3.55,3.55,0,1,1,6.49-2.89l16.5,37a3.56,3.56,0,0,1-3.24,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M2152.3,530.09a3.53,3.53,0,0,1-3.33-2.33L2136.7,494.1a3.55,3.55,0,1,1,6.67-2.43l12.27,33.65a3.55,3.55,0,0,1-2.12,4.55A3.46,3.46,0,0,1,2152.3,530.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1395.48,393c25.52,16.18,102.64,61.76,163.42,63.24a5.57,5.57,0,0,1,5.16,3.9l28.76,89.67a5.62,5.62,0,0,1-6.25,7.27c-33.76-5.51-152.94-28.85-198.6-89.23a5.6,5.6,0,0,1-1.13-3.4V397.73A5.63,5.63,0,0,1,1395.48,393Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1568.67,541.74a3.55,3.55,0,0,1-3.42-2.57l-21-72.93a3.55,3.55,0,0,1,6.82-2l21,72.93a3.55,3.55,0,0,1-2.43,4.39A3.36,3.36,0,0,1,1568.67,541.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1545.56,539.17a3.55,3.55,0,0,1-3.47-2.76l-16.69-73.87a3.55,3.55,0,1,1,6.93-1.57L1549,534.84a3.56,3.56,0,0,1-2.68,4.25A3.44,3.44,0,0,1,1545.56,539.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1516.39,496.07a3.56,3.56,0,0,1-3.44-2.71c-3-12.32-8-33.49-7.75-36.85a3.55,3.55,0,0,1,7.08.54c0,2.49,3.87,19.53,7.57,34.62a3.56,3.56,0,0,1-2.61,4.3A3.47,3.47,0,0,1,1516.39,496.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1430.23,490.47a3.56,3.56,0,0,1-3.55-3.45c-1.79-63.53-.11-66.28.52-67.31a3.55,3.55,0,0,1,6.3,3.23c-.87,4.12-.51,35.82.28,63.88a3.55,3.55,0,0,1-3.45,3.65Zm3-67.06h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication4);
export default __webpack_public_path__ + "static/media/application_4.5f93d8ca4381998682e5ae79701d7508.svg";
export { ForwardRef as ReactComponent };